export const UPDATE_TYPES = { IMAGE: "image", UPLOAD: "upload" };
export const OCR_STATUS_TYPES = {
  DEFAULT: "default",
  SUCCESS: "success",
  ACCEPTED: "accepted",
  ERROR: "error",
  CAPTURE: "capture",
};

export const OCR_ERROR_MESSAGES = {
  TechnicalError: "A apărut o eroare tehnică. Vă rugăm reîncercaţi mai tărziu",
  IdentityDocumentExpired:
    "Cartea de identitate pare că a expirat. Te rugăm să încarci o nouă imagine.",
  ImageNotClear:
    "Imaginea nu este suficient de clară. Te rugăm să încarci o nouă imagine.",
  InvalidFileType:
    "Formatul de fișier nu este suportat. Te rugăm să încarci o altă imagine.",
  BadRequest: "A apărut o eroare tehnică. Vă rugăm reîncercaţi mai tărziu",
  NonMatchingCnp:
    "Datele tale nu au putut fi validate. Te rugăm să încerci din nou și să te asiguri că datele de pe Cartea de Identitate corespund datelor folosite pentru autentificare. Dacă întâmpini dificultăți în continuare, contactează-ne folosind datele de mai jos.",
  ImageNotCI:
    "Cartea de identitate nu a putut fi localizată. Te rugăm să încarci o nouă imagine."
};

export const UPLOAD_ERROR_MESSAGES = {
  INVALID_FILE_TYPE:
    "Tipul fișierului nu a fost recunoscut. Te rugăm să încarci din nou poza cu documentul tău în oricare dintre formatele: .pdf, .jpeg, .png, .tiff, .bmp.",
  INVALID_FILE_SIZE:
    "Fișierul este prea mare. Asigură-te ca dimensiunea acestuia este de cel mult 5 MB și încearcă din nou.",
};

export const FILE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/bmp",
  "image/tiff",
  "application/pdf",
];
